import {
  Box,
  Button,
  Center,
  Group,
  Loader,
  Modal,
  MultiSelect,
  Stack,
  Text,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { OrganMapTemplate } from "../../../services/admin/organMapTemplates.service";
import { useSourcesAdmin } from "../../../hooks/admin/useSources";
import {
  useOrganMapTemplateLinkedSources,
  useLinkSourcesToOrganMapTemplate,
} from "../../../hooks/admin/useOrganMapTemplates";

interface SourcesModalProps {
  opened: boolean;
  onClose: () => void;
  template: OrganMapTemplate;
}

export default function SourcesModal({
  opened,
  onClose,
  template,
}: SourcesModalProps) {
  const { data: allSources = [], isLoading: sourcesLoading } =
    useSourcesAdmin();
  const { data: linkedSources = [] } = useOrganMapTemplateLinkedSources(
    template.id
  );
  const linkSources = useLinkSourcesToOrganMapTemplate();

  const activeSources = (allSources as any[]).filter((s: any) => s.isActive);
  const sourceOptions = activeSources.map((source: any) => ({
    value: source.id,
    label: source.name,
  }));

  const [selectedSourceIds, setSelectedSourceIds] = useState<string[]>([]);

  useEffect(() => {
    setSelectedSourceIds(linkedSources.map((s) => s.id));
  }, [linkedSources]);

  const handleSaveSources = async () => {
    await linkSources.mutateAsync({
      templateId: template.id,
      sourceIds: selectedSourceIds,
    });
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={`Linked Sources: ${template.name}`}
      size="lg"
      closeOnClickOutside={false}
    >
      <Stack gap="md">
        <Box>
          <Text size="sm" fw={500} mb={4}>
            Linked Sources
          </Text>
          <Text size="xs" c="dimmed" mb="xs">
            Select which sources should use this organ map template. All
            subsites from linked sources will be available for positioning.
          </Text>
          {sourcesLoading ? (
            <Center h={40}>
              <Loader size="xs" />
            </Center>
          ) : (
            <MultiSelect
              data={sourceOptions}
              placeholder="Search and select sources..."
              searchable
              clearable
              nothingFoundMessage="No sources found"
              value={selectedSourceIds}
              onChange={setSelectedSourceIds}
            />
          )}
        </Box>
        <Group justify="space-between">
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleSaveSources} loading={linkSources.isPending}>
            Save Sources
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
